/**
 * Created by Administrador on 15/12/2017.
 */
/**
 * Created by Alex Aguilar on 6/23/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('baseRateCorporateService', baseRateCorporateService)

    baseRateCorporateService.$inject = ['$http', 'CONFIG','messageService'];

    function baseRateCorporateService($http, CONFIG,messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/baseRateCorporates';

        var service = {
            saveBaseRateCorporate: saveBaseRateCorporate,
            updateBaseRateCorporate: updateBaseRateCorporate
        };

        return service;

        function saveBaseRateCorporate(baseRateCorporate){
            return $http.post(urlBase, baseRateCorporate)
                .then(function(){
                    messageService.registerUpdate('');
                    return "ok";
                }, function(){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }

        function updateBaseRateCorporate(id, baseRateCorporate){
            return $http.put(urlBase + "/" + id, baseRateCorporate)
                .then(function(){
                    messageService.registerUpdate('');
                    return "ok";
                }, function(){
                    messageService.registerUpdateError('');
                    return "error";
                });
        }
    }
})();
